<template>
  <div>
    <top-menu
      ref="top-menu"
      @logout="$emit('logout')"
    />
    <v-tabs
      align-tabs="center"
      fixed-tabs
      show-arrows
      :model-value="activeTab"
      :slider-color="themeClasses.color"
      color="grey-darken-4"
      class="top-tab v-theme--light v-tabs-bar"
    >
      <v-tab
        :to="{ name: 'daytimeAdviceRoom' }"
        class="my-0 me-0"
        value="0"
      >
        担当
      </v-tab>
      <v-tab
        v-if="isOperator"
        :to="{ name: 'daytimeAdviceMonitor' }"
        class="ma-0"
        value="1"
      >
        モニタリング
      </v-tab>
      <v-tab
        :to="{ name: 'daytimeAdviceSearch' }"
        class="my-0 ms-0"
        value="2"
      >
        検索
      </v-tab>
    </v-tabs>
    <v-container
      fluid
      class="list-container pa-0"
    >
      <v-row
        justify="center"
        class="my-0 fill-height"
      >
        <v-col class="fill-height pt-0 pb-0">
          <router-view v-slot="{ Component }">
            <v-fade-transition mode="out-in">
              <component
                :is="Component"
                class="daytime_advice"
              />
            </v-fade-transition>
          </router-view>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import TopMenu from "./shared/TopMenu.vue";
import environmentMixin from "../mixins/environment.js";
import {
  createRiskAssessmentDraftStore,
  RISK_ASSESSMENT_DRAFT_STORE_KEY
} from "@/vue/features/risk-assessment-input";

export default {
  name: "DaytimeAdviceHome",
  components: {
    TopMenu
  },
  mixins: [environmentMixin],
  // 日中助産師の画面内にいる間だけ、リスクアセスメントの入力途中の内容を相談ごとに保持する。
  provide() {
    return { [RISK_ASSESSMENT_DRAFT_STORE_KEY]: createRiskAssessmentDraftStore("日中助産師") };
  },
  emits: ["logout"],
  data: () => ({
  }),
  computed: {
    ...mapGetters(["currentDoctor", "hasAllCapabilities"]),
    isOperator() {
      return this.hasAllCapabilities(["operator:access"]);
    },
    // v-tab の :to による自動アクティブ判定は、詳細画面（sheet/:id, search/:id）が
    // ルート階層上「兄弟ルート」になっているため機能しないケースがある（特にリロード時）。
    // そのため現在のルート名から明示的にアクティブなタブを決定する。
    activeTab() {
      const routeName = this.$route.name;
      if (["daytimeAdviceRoom", "daytimeAdviceSheet"].includes(routeName)) return "0";
      if (routeName === "daytimeAdviceMonitor") return "1";
      if (["daytimeAdviceSearch", "daytimeAdviceSearchView"].includes(routeName)) return "2";
      return undefined;
    },
  },
  watch: {
  },
  created() {
  },
  methods: {
  }
};
</script>

<style lang="scss">
.daytime_advice {
  font-size: 14px;
}
.top-tab {
  .v-btn:not(.v-tab--selected){
    .v-btn__content {
      color: rgb(0 0 0 / 0.54) !important;
    }
  }
}
</style>
